export default __webpack_public_path__ + "cache-tile-fetching-scheme-960-d71ad3ecc0ca545f81c0f4fdd9f38bbc.webp";